export const debounce = (callback: any, delay: number) => {
  let timer: any;
  return (...args: any) => {
    clearTimeout(timer);
    setTimeout(() => callback(...args), delay);
  };
};
